module.exports = __webpack_public_path__ + "startpage-be63061f/A4-bd0b965b5964cb013f6346735d8413df.svg";